import ErrorCodes from '~/ui/pages/SignIn/models/ErrorCodes';

const isRefreshTokenError = (e: unknown): boolean => {
  const errorCode = (e as unknown as { response: { data: { code: string } } })?.response?.data
    ?.code as ErrorCodes;

  return errorCode === ErrorCodes.REFRESH_TOKEN_USED;
};

export default isRefreshTokenError;
